<script lang="ts">
  import type { FormChoiceType } from "@shared/common/node/type";
  import { simpleRandomId } from "../../../util/common";
  import FormCheckbox from "./form-checkbox.svelte";

  export let name: string;
  export let label: string = "";
  export let required: boolean | undefined = undefined;
  export let type: FormChoiceType = "CHECKBOX";
  export let id: string = simpleRandomId();
</script>

<div class="form-option">
  <FormCheckbox
    type={type === "CHECKBOX" ? "checkbox" : "radio"}
    {id}
    {name}
    {required}
    value={`${label}#${id}`}
  />

  <label for={id}>{label}</label>
</div>

<style>
  .form-option {
    display: flex;
    color: rgba(var(--cb-form-font-color), 0.9);
    justify-content: center;
    align-items: center;
    font-size: var(--cb-text-lg);
    line-height: var(--cb-line-height-lg);
    gap: calc(var(--cb-form-font-size) * 0.5);
  }

  .form-option > label {
    cursor: default;
  }
</style>
